module.exports = __webpack_public_path__ + "img/blog-video-triangle-small.237f2cac.svg";